/**
 * useNavPalette — общее состояние палитры быстрой навигации (клавиша `/`).
 *
 * Модульный синглтон на одном reactive-флаге: иконка-кнопка в AppHeader,
 * глобальный обработчик клавиш в App.vue и сам диалог NavPalette читают и
 * меняют одно и то же состояние. Pinia тут избыточна — это чисто UI-стейт
 * одного оверлея, без данных и без персистентности.
 */
import { ref } from 'vue'

const isOpen = ref(false)

export function useNavPalette() {
  function open(): void {
    isOpen.value = true
  }
  function close(): void {
    isOpen.value = false
  }
  function toggle(): void {
    isOpen.value = !isOpen.value
  }

  return { isOpen, open, close, toggle }
}
